/**
 * Konvertering mellom ISO 8601-strenger (slik API-et lagrer og sender `tid`/`slutt_tid`,
 * alltid UTC) og lokal tid som vises/redigeres i nettleseren. Brukes av
 * `ProductionHeaderTailwind` sitt redigeringsskjema.
 *
 * Viktig: `new Date(isoString)` og `Date.prototype.getFullYear/getHours/...` regner alltid
 * i nettleserens lokale tidssone - i motsetning til `isoString.slice(...)` som bare klipper
 * ut deler av UTC-strengen uten å konvertere. Funksjonene her bruker derfor `Date`-objektets
 * lokale gettere, aldri `slice` på selve ISO-strengen.
 */

function toToSifre(tall: number): string {
  return String(tall).padStart(2, '0');
}

/**
 * Konverterer en ISO 8601-streng (UTC) til en lokal `datetime-local`-verdi
 * (`YYYY-MM-DDTHH:mm`), slik `<input type="datetime-local">` forventer.
 */
export function isoTilLokalDatetimeLocal(iso: string): string {
  const dato = new Date(iso);
  const aar = dato.getFullYear();
  const maaned = toToSifre(dato.getMonth() + 1);
  const dag = toToSifre(dato.getDate());
  const time = toToSifre(dato.getHours());
  const minutt = toToSifre(dato.getMinutes());
  return `${aar}-${maaned}-${dag}T${time}:${minutt}`;
}

/**
 * Konverterer en lokal `datetime-local`-verdi (`YYYY-MM-DDTHH:mm`, slik nettleseren tolker
 * den i lokal tid) til en ISO 8601-streng (UTC), slik API-et forventer.
 */
export function lokalDatetimeLocalTilIso(lokalVerdi: string): string {
  return new Date(lokalVerdi).toISOString();
}

/**
 * Konverterer en ISO 8601-streng (UTC) til lokalt klokkeslett (`HH:mm`).
 */
export function isoTilLokalHHMM(iso: string): string {
  const dato = new Date(iso);
  return `${toToSifre(dato.getHours())}:${toToSifre(dato.getMinutes())}`;
}
